import companiesApiServices from "../apiServices/companiesApiServices";

export default {
    companies: new companiesApiServices(),
}